// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1__e6d04588d5246d86b835","cls2":"SuggestionCard-cls2__f15f62be4b4608727d83 SuggestionCard-cls1__e6d04588d5246d86b835"};